









import Vue from 'vue'

interface HitCountComputed {
	count: number
	searchedQuery: string
	countPresentation: number | string
}

export default Vue.extend<{}, {}, HitCountComputed, {}>({
	name: 'CategoryFilter',
	computed: {
		count() {
			return Number(this.$store.getters.total)
		},
		searchedQuery() {
			return this.$store.getters.searchedQuery
		},
		countPresentation() {
			return this.count > 0 ? this.count : 'tyvärr inga'
		}
	}
})
